module.exports = __webpack_public_path__ + "static/media/chanel-logo-black.93b9df71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/chanel-logo-black.svg
// module id = 301
// module chunks = 0